window.VCA = window.VCA || {};

window.VCA.raaDatalayer = (function ($) {

    if ($('.req-appt__wrapper').length <= 0) {
        return;
    }

    function datalayerPushPageLoad(data) {
        //push to datalayer step-1
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'raa-page-view',
            'hospital-name': data.hospitalName,
            'hospital-type': data.hospitalType,
            'hopital-AAU': data.hospitalIDValue,
            'Logged-in-status': data.isLoggedIn,
        });
    }


    function datalayerPushStepChange(data, currentPage, previousPageName) {
        let extraData =[
            'resouceName',
            'preferredTime1',
            'petName',
        ]

        let stepInfo = {
            'event': 'raa-step-change',
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'Logged-in-status': data.isLoggedIn,
            'resouceName': '',
            'preferredTime1': '',
            'petName': '',
        };

        extraData.forEach((dataPoint) => {
            if(data[dataPoint] !== '' && data[dataPoint] !== null) {
                stepInfo[dataPoint] = data[dataPoint];
            }
        }) 



        //push to datalayer step-1
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(stepInfo);
    }

    function datalayerPushComfirm(data) {
        //push step-4
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'raa-submit',
            'doc-name': data.resouceName,
            'time-of-day': data.preferredTime1,
            'pet-name': data.petName,
            'Logged-in-status': data.isLoggedIn,
            'current-page-name': 'submission',
        });
    }

    function datalayerPushPostSubmit(data) {
        window.dataLayer.push({
            'event': 'raa-post-submission',
            'doc-name': data.resouceName,
            'time-of-day': data.preferredTime1,
            'pet-name': data.petName,
            'Logged-in-status': data.isLoggedIn,
            'current-page-name': 'post-submission',
        });
    }

    
    function datalayerPushAbandon(data, currentPage) {

        let extraData =[
            'resouceName',
            'preferredTime1',
            'petName',
        ]

        let stepInfo = {
            'event': 'raa-abandon',
            'current-page-name': currentPage,
            'Logged-in-status': data.isLoggedIn,
            'resouceName': '',
            'preferredTime1': '',
            'petName': '',
        };

        extraData.forEach((dataPoint) => {
            if(data[dataPoint] !== '' && data[dataPoint] !== null) {
                stepInfo[dataPoint] = data[dataPoint];
            }
        }) 


        //push to datalayer abandon
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(stepInfo);
    }

    return {
        datalayerPushPageLoad: datalayerPushPageLoad,
        datalayerPushComfirm: datalayerPushComfirm,
        datalayerPushPostSubmit: datalayerPushPostSubmit,
        datalayerPushStepChange: datalayerPushStepChange,
        datalayerPushAbandon: datalayerPushAbandon,
    };



})(jQuery);